<template>
  <div class>
    <Loading v-if="!fetchedData" loadingString="Passwords" />
    <div
      v-else
      id="mainDiv"
      class="container roundedBorder secondary-bg primary-fg"
    >
      <h2>Passwords</h2>
      <div class="col s12">
        <div class="row">
          <div v-if="passwords.length > 0" class="input-field col s8 m9">
            <i class="material-icons prefix secondary-fg">search</i>
            <textarea
              id="icon_prefix2"
              class="materialize-textarea primary-fg textareaBorder"
              v-model="searchValue"
            ></textarea>
            <label for="icon_prefix2">Search</label>
          </div>
          <div class="col s4 m3" style="padding-top: 20px">
            <a
              v-on:click="showNewPasswordModal()"
              class="waves-effect waves-light primary-bg primary-fg btn s12"
              style="width: 100%"
            >
              New password
              <i class="material-icons left">add</i>
            </a>
          </div>
        </div>

        <ul class="collapsible">
          <li v-for="password in passwords" :key="password.guid">
            <template
              v-if="
                password.content
                  .toLowerCase()
                  .includes(searchValue.toLowerCase())
              "
            >
              <div
                class="collapsible-header primary-bg primary-fg"
                style="color: black; overflow: hidden; white-space: nowrap"
              >
                <img
                  v-if="password.website != undefined && password.website != ''"
                  :src="
                    `https://s2.googleusercontent.com/s2/favicons?domain=${password.website
                      .replace('https://', '')
                      .replace('http://', '')}`
                  "
                  alt="favicon"
                  style="height: 22px; width: 22px; margin-right: 20px"
                  class="loading"
                  onload="this.classList.remove('loading')"
                  v-on:click="openUrlAtNewTab(password.website)"
                  onerror="this.remove()"
                />
                <i v-else class="material-icons">vpn_key</i>
                <i
                  v-if="password.isFavorite"
                  class="material-icons secondary-fg"
                  >star</i
                >
                <i
                  v-if="getPasswordScore(password.password) < 50"
                  class="material-icons secondary-fg"
                  >error_outline</i
                >
                <i
                  v-if="getSamePasswordContents(password) != ''"
                  style=""
                  class="material-icons secondary-fg"
                  >loop</i
                >
                {{ password.content }}
              </div>
              <div class="collapsible-body">
                <div class="row valign-wrapper">
                  <h5 class="col">Username</h5>
                  <a
                    v-on:click="copyTextToClipboard(password.username)"
                    class="waves-effect waves-light btn primary-bg col"
                    ><i class="material-icons">content_copy</i></a
                  >
                </div>

                <p></p>
                <span
                  v-on:click="copyTextToClipboard(password.username)"
                  class="secondary-fg"
                  >{{ password.username }}</span
                >
                <p></p>
                <div class="row valign-wrapper">
                  <h5 class="col">Password</h5>
                  <a
                    v-on:click="copyTextToClipboard(password.password)"
                    class="waves-effect waves-light btn primary-bg col"
                    ><i class="material-icons">content_copy</i></a
                  >
                  <span style="width:12px !important"></span>
                  <a
                    v-on:click="
                      password.revealPassword = !password.revealPassword
                    "
                    class="waves-effect waves-light btn primary-bg col"
                    ><i class="material-icons">remove_red_eye</i></a
                  >
                </div>
                <p></p>
                <span
                  v-on:click="copyTextToClipboard(password.password)"
                  class="secondary-fg"
                  >{{
                    password.revealPassword
                      ? password.password
                      : "*".repeat(password.password.length)
                  }}</span
                >
                <p></p>
                <div
                  v-if="password.website != undefined && password.website != ''"
                >
                  <div class="row valign-wrapper">
                    <h5 class="col">Website</h5>
                    <a
                      v-on:click="copyTextToClipboard(password.website)"
                      class="waves-effect waves-light btn primary-bg col"
                      ><i class="material-icons">content_copy</i></a
                    >
                  </div>
                  <div
                    v-if="
                      !(
                        password.website.startsWith('http://') ||
                        password.website.startsWith('https://')
                      )
                    "
                  >
                    <p></p>
                    <span class="error-fg">
                      Looks like this website url is broken, please make sure
                      the url starts with http://
                    </span>
                  </div>

                  <p></p>
                  <img
                    :src="
                      `https://s2.googleusercontent.com/s2/favicons?domain=${password.website
                        .replace('https://', '')
                        .replace('http://', '')}`
                    "
                    loading="lazy"
                    alt="favicon"
                    style="height: 32px; width: 32px"
                    class="loading"
                    onload="this.classList.remove('loading')"
                    v-on:click="openUrlAtNewTab(password.website)"
                    onerror="this.remove()"
                  />
                  <p></p>
                  <a target="_blank" :href="password.website">{{
                    password.website
                  }}</a>
                  <p></p>
                </div>

                <div
                  v-if="
                    password.notes != null &&
                      password.notes != undefined &&
                      password.notes != ''
                  "
                >
                  <div class="row valign-wrapper">
                    <h5 class="col">Notes</h5>
                    <a
                      v-on:click="copyTextToClipboard(password.notes)"
                      class="waves-effect waves-light btn primary-bg col"
                      ><i class="material-icons">content_copy</i></a
                    >
                  </div>
                  <p></p>
                  <span
                    style="overflow-wrap: break-word"
                    class="secondary-fg"
                    >{{ password.notes }}</span
                  >
                </div>

                <h5>Details</h5>
                <div v-if="getPasswordScore(password.password) < 50">
                  <p></p>
                  <span class="error-fg">
                    This password is weak and vulnerable! Please take action and
                    update your password, a strong password should be a minimum
                    of 12 characters, and contain letters, numbers, and symbols
                    at the same time.
                  </span>
                </div>
                <p></p>
                <span>
                  Your password score is:
                  <span class="secondary-fg">{{
                    `${getPasswordScore(password.password)}%`
                  }}</span>
                </span>
                <div v-if="getSamePasswordContents(password) != ''">
                  <p></p>
                  <span class="">
                    You are reusing this password on other platforms, including
                    <span class="secondary-fg">{{
                      getSamePasswordContents(password)
                    }}</span>
                    . This increases the risk to this account if one of those
                    accounts is compromised. You should change your password
                    immediately.
                  </span>
                </div>

                <p></p>
                <a
                  v-on:click="toggleFavoriteStatus(password.guid)"
                  class="waves-effect waves-light btn-small primary-bg secondary-fg"
                >
                  <i class="material-icons">
                    {{ password.isFavorite ? "star" : "star_border" }}
                  </i>
                </a>
                <p></p>
                <a
                  v-on:click="toggleEditModal(password.guid)"
                  class="waves-effect waves-light btn-small primary-bg"
                  >Edit</a
                >
                <p></p>
                <a
                  v-on:click="removePassword(password.guid)"
                  class="waves-effect waves-light btn-small red darken-3"
                  >Remove</a
                >
              </div>
            </template>
          </li>
        </ul>
      </div>

      <div v-if="passwords.length == 0">
        <h6 class="">
          Save your passwords here, or click
          <router-link to="/passwords/import">here</router-link>
          to simply import all of your passwords from Google
        </h6>
      </div>
    </div>

    <!-- New password Modal Structure -->
    <div id="newPasswordModal" class="modal bottom-sheet">
      <div class="modal-content">
        <h4>New password</h4>

        <div class="input-field col s6">
          <i class="material-icons prefix black-text">dashboard</i>
          <input id="newPasswordPlatform" type="text" class="validate" />
          <label for="newPasswordPlatform" class="black-text">Platform</label>
        </div>

        <div class="input-field col s6">
          <i class="material-icons prefix black-text">explore</i>
          <input id="newPasswordWebsite" type="url" class="validate" />
          <label for="newPasswordWebsite" class="black-text">Website</label>
        </div>

        <div class="input-field col s6">
          <i class="material-icons prefix black-text">account_circle</i>
          <input id="newPasswordUsername" type="text" class="validate" />
          <label for="newPasswordUsername" class="black-text">Username</label>
        </div>

        <div class="input-field col s6">
          <i class="material-icons prefix black-text">vpn_key</i>
          <input id="newPasswordPassword" type="text" class="validate" />
          <label for="newPasswordPassword" class="black-text">Password</label>
        </div>

        <div class="input-field col s6">
          <i class="material-icons prefix black-text">event_note</i>
          <input id="newPasswordNotes" type="text" />
          <label for="newPasswordNotes" class="black-text">Notes</label>
        </div>
      </div>
      <div class="modal-footer">
        <a
          v-on:click="saveNewPassword"
          class="waves-effect waves-green btn-flat"
          >Save</a
        >
      </div>
    </div>

    <!-- Edit password Modal Structure -->
    <div id="editPasswordModal" class="modal bottom-sheet">
      <div class="modal-content">
        <h4>Edit password</h4>

        <div class="input-field col s6">
          <i class="material-icons prefix black-text">dashboard</i>
          <input
            id="editPasswordPlatform"
            placeholder="Platform"
            type="text"
            class="validate"
          />
          <label for="editPasswordPlatform" class="black-text active"
            >Platform</label
          >
        </div>

        <div class="input-field col s6">
          <i class="material-icons prefix black-text">explore</i>
          <input
            id="editPasswordWebsite"
            placeholder="Website"
            type="url"
            class="validate"
          />
          <label for="editPasswordWebsite" class="black-text active"
            >Website</label
          >
        </div>

        <div class="input-field col s6">
          <i class="material-icons prefix black-text">account_circle</i>
          <input
            id="editPasswordUsername"
            placeholder="Username"
            type="text"
            class="validate"
          />
          <label for="editPasswordUsername" class="black-text active"
            >Username</label
          >
        </div>

        <div class="input-field col s6">
          <i class="material-icons prefix black-text">vpn_key</i>
          <input
            id="editPasswordPassword"
            placeholder="Password"
            type="text"
            class="validate"
          />
          <label for="editPasswordPassword" class="black-text active"
            >Password</label
          >
        </div>

        <div class="input-field col s6">
          <i class="material-icons prefix black-text">event_note</i>
          <input id="editPasswordNotes" placeholder="Notes" type="text" />
          <label for="editPasswordNotes" class="black-text active">Notes</label>
        </div>
      </div>
      <div class="modal-footer">
        <a v-on:click="updatePassword" class="waves-effect waves-green btn-flat"
          >Save changes</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import M from "materialize-css";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import Loading from "../components/Loading.vue";
import { SecretPasswordObject, PASSWORDS_API_ENDPOINT } from "../common.js";

export default {
  name: "Passwords",
  components: {
    Loading
  },
  data: function() {
    return {
      searchValue: "",
      passwords: [],
      lastEditGUID: "",
      fetchedData: false
    };
  },
  methods: {
    guid: function() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return (
        s4() +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        s4() +
        s4()
      );
    },
    saveNewPassword: async function() {
      // Get the provided information
      let content = document.getElementById("newPasswordPlatform").value;
      let username = document.getElementById("newPasswordUsername").value;
      let password = document.getElementById("newPasswordPassword").value;
      let website = document.getElementById("newPasswordWebsite").value;
      let notes = document.getElementById("newPasswordNotes").value;

      // Check if any of them is empty
      if (content == "" || username == "" || password == "") {
        alert("Please fill all fields.");
        return;
      }

      // Check if the website url has the http protocol in it
      if (
        website != "" &&
        !website.startsWith("http://") &&
        !website.startsWith("https://")
      ) {
        website = "https://" + website;
      }

      let cseEnabled = await this.isCSEEnabled();

      let passwordGuid = this.guid();
      let idToken = await this.getIdToken();
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: idToken
        },
        body: JSON.stringify({
          password: {
            content: cseEnabled ? this.encrypt(content) : content,
            password: cseEnabled ? this.encrypt(password) : password,
            username: cseEnabled ? this.encrypt(username) : username,
            website: cseEnabled ? this.encrypt(website) : website,
            guid: passwordGuid,
            isFavorite: cseEnabled ? this.encrypt(false) : false,
            notes: cseEnabled ? this.encrypt(notes) : notes
          }
        })
      };
      let serverResponse = await fetch(PASSWORDS_API_ENDPOINT, options).then(
        res => {
          return res.json();
        }
      );
      if (!serverResponse.success) {
        alert(`Failed while saving the password: ${serverResponse.data}`);
        return;
      }

      // Also manually add the data to local array (as first element to show it at top)
      this.passwords = [
        ...[
          new SecretPasswordObject(
            passwordGuid,
            content,
            username,
            password,
            website,
            false,
            notes
          )
        ],
        ...this.passwords
      ];

      // Clear the input fields and close the modal
      document.getElementById("newPasswordPlatform").value = "";
      document.getElementById("newPasswordUsername").value = "";
      document.getElementById("newPasswordPassword").value = "";
      document.getElementById("newPasswordWebsite").value = "";
      document.getElementById("newPasswordNotes").value = "";
      M.Modal.getInstance(document.querySelector("#newPasswordModal")).close();
      M.updateTextFields();
    },
    copyTextToClipboard: function(text) {
      var selected = false;
      var el = document.createElement("textarea");
      el.value = text;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      if (document.getSelection().rangeCount > 0) {
        selected = document.getSelection().getRangeAt(0);
      }
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }

      M.toast({
        html: "Copied to the clipboard!",
        displayLength: 1000
      });
    },
    removePassword: async function(passwordGuid) {
      let idToken = await this.getIdToken();

      const options = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: idToken
        },
        body: JSON.stringify({
          password: {
            guid: passwordGuid
          }
        })
      };
      let serverResponse = await fetch(PASSWORDS_API_ENDPOINT, options).then(
        res => {
          return res.json();
        }
      );
      if (!serverResponse.success) {
        alert(`Failed while deleting the password: ${serverResponse.data}`);
        return;
      }

      // Then remove from the local array
      this.passwords = this.passwords.filter(p => p.guid !== passwordGuid);
    },
    toggleFavoriteStatus: async function(passwordGuid) {
      // Update the local array
      let index = this.passwords.map(p => p.guid).indexOf(passwordGuid);
      this.passwords[index].isFavorite = !this.passwords[index].isFavorite;

      let cseEnabled = await this.isCSEEnabled();
      let idToken = await this.getIdToken();
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: idToken
        },
        body: JSON.stringify({
          password: {
            content: cseEnabled
              ? this.encrypt(this.passwords[index].content)
              : this.passwords[index].content,
            password: cseEnabled
              ? this.encrypt(this.passwords[index].password)
              : this.passwords[index].password,
            username: cseEnabled
              ? this.encrypt(this.passwords[index].username)
              : this.passwords[index].username,
            website: cseEnabled
              ? this.encrypt(this.passwords[index].website)
              : this.passwords[index].website,
            guid: passwordGuid,
            isFavorite: cseEnabled
              ? this.encrypt(this.passwords[index].isFavorite)
              : this.passwords[index].isFavorite,
            notes: cseEnabled
              ? this.encrypt(this.passwords[index].notes)
              : this.passwords[index].notes
          }
        })
      };
      let serverResponse = await fetch(PASSWORDS_API_ENDPOINT, options).then(
        res => {
          return res.json();
        }
      );
      if (!serverResponse.success) {
        alert(`Failed while updating the password: ${serverResponse.data}`);
        return;
      }
    },
    toggleEditModal: function(passwordGuid) {
      // Get the password object with the given guid
      let passwordToEdit = this.passwords.find(p => p.guid == passwordGuid);

      // Set the value of #editPasswordModal's input fields
      // according to the found password object
      document.getElementById("editPasswordPlatform").value =
        passwordToEdit.content;
      document.getElementById("editPasswordWebsite").value =
        passwordToEdit.website;
      document.getElementById("editPasswordUsername").value =
        passwordToEdit.username;
      document.getElementById("editPasswordPassword").value =
        passwordToEdit.password;
      document.getElementById("editPasswordNotes").value = passwordToEdit.notes;

      // Save the guid for saving afterwards
      this.lastEditGUID = passwordGuid;

      // Show the modal
      let editModal = document.querySelector("#editPasswordModal");
      M.Modal.getInstance(editModal).open();
    },
    updatePassword: async function() {
      // Get the new properties
      let newPlatform = document.getElementById("editPasswordPlatform").value;
      let newUsername = document.getElementById("editPasswordUsername").value;
      let newPassword = document.getElementById("editPasswordPassword").value;
      let newWebsite = document.getElementById("editPasswordWebsite").value;
      let newNotes = document.getElementById("editPasswordNotes").value;

      // Check if any of them is empty
      if (newPlatform == "" || newUsername == "" || newPassword == "") {
        alert("Please fill all fields.");
        return;
      }

      // Check if the website url has http protocol in it
      if (
        newWebsite != "" &&
        !newWebsite.startsWith("http://") &&
        !newWebsite.startsWith("https://")
      ) {
        newWebsite = "https://" + newWebsite;
      }

      let index = this.passwords.map(p => p.guid).indexOf(this.lastEditGUID);
      let isFavorite = this.passwords[index].isFavorite;

      let cseEnabled = await this.isCSEEnabled();
      let idToken = await this.getIdToken();
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: idToken
        },
        body: JSON.stringify({
          password: {
            content: cseEnabled ? this.encrypt(newPlatform) : newPlatform,
            password: cseEnabled ? this.encrypt(newPassword) : newPassword,
            isFavorite: cseEnabled ? this.encrypt(isFavorite) : isFavorite,
            username: cseEnabled ? this.encrypt(newUsername) : newUsername,
            website: cseEnabled ? this.encrypt(newWebsite) : newWebsite,
            guid: this.lastEditGUID,
            notes: cseEnabled ? this.encrypt(newNotes) : newNotes
          }
        })
      };
      let serverResponse = await fetch(PASSWORDS_API_ENDPOINT, options).then(
        res => {
          return res.json();
        }
      );
      if (!serverResponse.success) {
        alert(`Failed while saving the password: ${serverResponse.data}`);
        return;
      }

      // Update the local array
      this.passwords[index].content = newPlatform;
      this.passwords[index].username = newUsername;
      this.passwords[index].password = newPassword;
      this.passwords[index].website = newWebsite;
      this.passwords[index].notes = newNotes;

      // Dismiss the modal
      let editModal = document.querySelector("#editPasswordModal");
      M.Modal.getInstance(editModal).close();
    },
    showNewPasswordModal: function() {
      let newPasswordModal = document.querySelector("#newPasswordModal");
      M.Modal.getInstance(newPasswordModal).open();
    },
    openUrlAtNewTab: function(url) {
      window.open(url, "_blank");
    },
    getSamePasswordContents: function(password) {
      let foundContents = [];
      this.passwords.forEach(pass => {
        if (pass != password && pass.password == password.password) {
          foundContents.push(pass.content);
        }
      });

      if (foundContents.length == 0) return "";
      if (foundContents.length == 1) return foundContents[0];
      if (foundContents.length == 2)
        return `${foundContents[0]} and ${foundContents[1]}`;

      let lastElement = foundContents.splice(foundContents.length - 1, 1);
      let str = foundContents.join(", ");
      str += `, and ${lastElement}`;
      return str;
    },
    getPasswordScore: function(password) {
      // This calculation is inspired by http://www.passwordmeter.com/
      /* NOT EXACTLY EQUAL TO THE REFERENCE WEBSITE */

      // Calculate the additions to the score
      let numOfChars = password.length;
      let upperCaseLetters = 0,
        lowerCaseLetters = 0,
        numbers = 0,
        symbols = 0,
        middleNumsOrSymbols = 0,
        score = 0;
      for (let i = 0; i < password.length; i++) {
        let c = password[i];
        if (c.match(/\p{Lu}/u)) upperCaseLetters++;
        else if (c.match(/\p{Ll}/u)) lowerCaseLetters++;
        else if (c.match(/[0-9]/)) numbers++;
        //eslint-disable-next-line
        else if (c.match(/[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/)) symbols++;
        if (
          i != 0 &&
          i != password.length - 1 &&
          //eslint-disable-next-line
          (c.match(/[0-9]/) || c.match(/[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/))
        )
          middleNumsOrSymbols++;
      }

      // Now calculate the + points
      score += numOfChars * 3;
      score += (numOfChars - upperCaseLetters) * 2;
      score += (numOfChars - lowerCaseLetters) * 2;
      score += numbers * 2;
      score += symbols * 6;
      score += middleNumsOrSymbols * 2;

      // Requirements
      if (
        numOfChars >= 8 &&
        upperCaseLetters > 0 &&
        lowerCaseLetters > 0 &&
        numbers > 0 &&
        symbols > 0
      ) {
        score += numOfChars >= 8 ? 2 : 0;
        score += upperCaseLetters >= 1 ? 2 : 0;
        score += lowerCaseLetters >= 1 ? 2 : 0;
        score += numbers >= 1 ? 2 : 0;
        score += symbols >= 1 ? 2 : 0;
      }

      // Calculate the deductions to the score

      let consecutiveUpperCaseLetters = 0,
        consecutiveLowerCaseLetters = 0,
        consecutiveNumbers = 0,
        threeSequentialCharacters = 0;

      for (let i = 0; i < password.length - 1; i++) {
        let c = password[i];
        let nextC = password[i + 1];
        if (c.match(/\p{Lu}/u) && nextC.match(/\p{Lu}/u))
          consecutiveUpperCaseLetters++;
        else if (c.match(/\p{Ll}/u) && nextC.match(/\p{Ll}/u))
          consecutiveLowerCaseLetters++;
        else if (c.match(/[0-9]/) && nextC.match(/[0-9]/)) consecutiveNumbers++;

        if (i < password.length - 2) {
          let nextNextC = password[i + 2];
          if (
            c.charCodeAt(0) == nextC.charCodeAt(0) - 1 &&
            nextC.charCodeAt(0) == nextNextC.charCodeAt(0) - 1
          )
            threeSequentialCharacters++;
        }
      }

      // Letters only
      score -=
        upperCaseLetters + lowerCaseLetters == numOfChars ? numOfChars : 0;
      score -= numbers == numOfChars ? numOfChars : 0;
      score -= consecutiveUpperCaseLetters * 2;
      score -= consecutiveLowerCaseLetters * 2;
      score -= consecutiveNumbers * 2;
      score -= threeSequentialCharacters * 3;

      score = score > 100 ? 100 : score;
      score = score < 0 ? 0 : score;

      return score;
    }
  },
  mounted: async function() {
    // If there is no user navigate to the root page
    if (!firebase.auth().currentUser) {
      this.$router.push("/");
      return;
    }

    // Initialize the materialize components
    // This also closes the navbar if open
    M.AutoInit();

    // Fetch the passwords
    this.passwords = await this.fetchPasswords();
    this.fetchedData = true;

    let isCollapsibleCreated = setInterval(function() {
      var elems = document.querySelectorAll(".collapsible");
      if (elems.length) {
        M.Collapsible.init(elems, {});
        clearInterval(isCollapsibleCreated);
      }
    }, 100);
  },
  metaInfo: {
    title: "Passwords",
    meta: [
      {
        name: "description",
        content: "Store encypted passwords with LockerApp."
      },
      { name: "application-name", content: "LockerApp" },
      { name: "author", content: "Emre Biçer" },
      {
        name: "keywords",
        content:
          "LockerApp, Locker App, Locker, App, Password Manager, Password, Safe, Application, Last Password, Locker, Notes, Note Application, Mobile Application, Web Application"
      }
    ]
  }
};
</script>

<style scoped>
#mainDiv {
  padding: 20px;
}

.modal {
  max-height: 100%;
  overflow: visible;
}

.loading {
  background-image: url("../assets/loading.gif");
  background-size: 100%;
}
</style>
